import { render, staticRenderFns } from "./HowToUsePage.vue?vue&type=template&id=a35de864&scoped=true&"
import script from "./HowToUsePage.vue?vue&type=script&lang=js&"
export * from "./HowToUsePage.vue?vue&type=script&lang=js&"
import style0 from "./HowToUsePage.vue?vue&type=style&index=0&id=a35de864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35de864",
  null
  
)

export default component.exports